import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { Translations } from '@app/core/services/i18n/translations.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-expanding-details',
  templateUrl: './expanding-details.component.html',
  styleUrls: ['./expanding-details.component.scss']
})
export class ExpandingDetailsComponent implements OnInit, OnChanges {
  constructor(public translateService: TranslateService, public translations: Translations) {}

  @Input() icon: string;
  @Input() label: string;
  @Output() emitExpansionButtonEvent = new EventEmitter<void>();
  @Input() isExpanded = false;
  @Input() bottomBorderOnExpanded = false;
  @Input() showTooltip = false;
  @Input() tooltipText: string;
  @Input() isAnyDisplayableField = true;
  @Input() flexDirection = 'row';
  @Input() showDriverStatus = false;
  @Input() set driverActivityStatus(status: string) {
    this._driverActivityStatus = this.mapDriverStatus(status);
    this._activityGlyph = this.getActivityGlyph(status);
  }

  expandMore = 'expand_more';
  expandLess = 'expand_less';
  expansionIcon = this.expandMore;
  _driverActivityStatus: string = 'unknown';
  _activityGlyph: string;
  ngOnInit() {
    // necessary if input manually defaults to true by a consuming component
    if (this.isExpanded === true) {
      this.expansionIcon = this.expandLess;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      Object.prototype.hasOwnProperty.call(changes, 'isExpanded') &&
      Object.prototype.hasOwnProperty.call(changes?.isExpanded, 'currentValue')
    ) {
      this.isExpanded = changes?.isExpanded?.currentValue;
      this.expansionIcon = this.isExpanded ? this.expandLess : this.expandMore;
    }
  }

  onExpansionClick(): void {
    if (!this.isAnyDisplayableField) return;
    this.isExpanded = !this.isExpanded;
    this.expansionIcon = this.isExpanded ? this.expandLess : this.expandMore;
    this.emitExpansionButtonEvent.emit();
  }

  getActivityGlyph(status: string): string {
    switch (status?.toLowerCase()) {
      case 'driving':
        return 'U';
      case 'active':
        return 'V';
      case 'rest':
        return 'X';
      case 'passive':
        return 'W';
      default:
        return 'R';
    }
  }

  mapDriverStatus(status: string): string {
    switch (status?.toLowerCase()) {
      case 'driving':
      case 'rest':
        return status.toLowerCase();
      case 'active':
        return 'work';
      case 'passive':
        return 'available';
      default:
        return 'unknown';
    }
  }
}
